module.exports = __webpack_public_path__ + "img/shuilian.29eb1e2c.png";